import {
    GET_RESTAURANT_DATA,
    SET_RESTAURANT_PARTIAL_DATA,
    SHOW_RESTAURANT_TAB,
    tabs
} from '../actions/restaurant.actions';

const initialState = {
    data: null,
    activeTab: tabs.menu
};

const restaurantReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_RESTAURANT_DATA:
            return {
                ...state,
                data: action.payload
            };
        case SET_RESTAURANT_PARTIAL_DATA:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload
                }
            };
        case SHOW_RESTAURANT_TAB:
            return {
                ...state,
                activeTab: action.payload
            };
        default:
            return state;
    }
}

export default restaurantReducer;